import { useCallback, useContext } from 'react';
import { getMockAuth } from './mockServices'
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import { useAuth0 } from '@auth0/auth0-react';

export const useAuthHeader = () => {
    const { userId } = useContext(UserSettingsContext);
    const { getAccessTokenSilently } = useAuth0();
    const { isMockEnabled, mockToken } = getMockAuth()

    const getToken = useCallback(async () => {
        try {
            return isMockEnabled ? mockToken : await getAccessTokenSilently();
        } catch (error) {
            console.error('Error generating access token:', error);
            throw error;
        }
    }, [getAccessTokenSilently, isMockEnabled, mockToken]);

    const getHttpHeaders = useCallback(async (tenantId) => {
        const accessToken = await getToken();
        return {
            Authorization: `Bearer ${accessToken}`,
            'Tenant-ID': tenantId || userId?.tenant_id
        };
    }, [getToken, userId?.tenant_id]);

    const getSocketAuth = useCallback(async (tenantId) => {
        const accessToken = await getToken();
        return {
            token: accessToken,
            tenant_id: tenantId || userId?.tenant_id
        };
    }, [getToken, userId?.tenant_id]);

    return { getHttpHeaders, getSocketAuth };
};